import AddToHomeScreen from './AddToHomeScreen.container'

export default AddToHomeScreen
